import { Component } from '@angular/core';
declare const $;

@Component({
    selector: 'app-left-data',
    templateUrl: './left-data.component.html',
    styleUrls: ['./left-data.component.css'],
    standalone: false
})
export class LeftDataComponent {

  public openTabTracking(tabName: string, headNum: number)
  {
      var x = $("#topleft .tabpage");
      for (var i = 0; i < x.length; i++)
        $(x[i]).addClass("hidden");
  
      $("." + tabName).removeClass("hidden");

      x = $("#topleftbtntabs button");
      for (var i = 0; i < x.length; i++)
        $(x[i]).removeClass("active");
  
      $(x[headNum - 1]).addClass("active");

      x = $("#bottomleft .tabpage");
      for (var i = 0; i < x.length; i++)
        $(x[i]).addClass("hidden");
      $("#" + tabName + "bottom").removeClass("hidden");
  }
}
